module.exports = __webpack_public_path__ + "static/img/02-05.30c76a79.png";